import cp from 'class-propper';

class PageRecord {
  constructor(props = {}) {
    Object.assign(this, props);
  }

  safeKey() {
    if (this.link && !/^no-link-/.test(this.key)) {
      return `no-link-${this.key}`;
    }
    return this.key;
  }
}

cp(PageRecord)
  .addProp('icon', {
    defaultValue: 'none',
    type: 'string',
  })
  .addProp('parent', {
    type: 'string',
    defaultValue: '',
  })
  .addProp('order', {
    type: 'number',
    defaultValue: 0,
  })
  .addProp('onHomePage', {
    type: 'boolean',
    defaultValue: true,
  })
  .addProp('route', {
    type: 'string',
    defaultValue: '/',
  })
  .addProp('onMenu', {
    type: 'boolean',
    defaultValue: true,
  })
  .addProp('exact', {
    type: 'boolean',
    defaultValue: false,
  })
  .addProp('access', {
    type: 'array',
    defaultValue: () => ([]),
  })
  .addProp('name', {
    type: 'string',
    required: true,
  })
  .addProp('description', {
    type: 'string',
    defaultValue: '',
  })
  .addProp('key', {
    required: true,
    type: 'string',
  })
  .addProp('image', {
    defaultValue: '',
    type: 'string',
  })
  .addProp('link', {
    defaultValue: '',
    type: 'string',
  });

export default PageRecord;
